export const sortNumbersAscending = (a: number, b: number): number => a - b;
